// extracted by mini-css-extract-plugin
module.exports = {"banner":"CourseDetails_banner__-ow7A","section-wrapper":"CourseDetails_section-wrapper__3n67S","wrapper":"CourseDetails_wrapper__2TMT8","spinner":"CourseDetails_spinner__SrDRm"};